<template lang="html">
  <horizontal-bar-chart :chartData="chartData" :options="options" v-if="chartData !== undefined"></horizontal-bar-chart>
  <spinner v-else></spinner>
</template>

<script>
import HorizontalBarChart from '@/pages/statistics/components/graphiques/HorizontalBarChart.vue'
import Spinner from '@/components/common/spinner.vue'
import * as R from 'ramda'

export default {
  props: ['showSentNotReceived', 'showAmountNotNumber'],
  data () {
    return {
      chartData: undefined,
      options: undefined
    }
  },
  components: {
    'horizontal-bar-chart': HorizontalBarChart,
    'spinner': Spinner
  },
  created () {
    // this.$engine.monitoring.initAllGraphs()
    this.options = {responsive: true}
  },
  mounted () {
    if (this.$engine.monitoring.graphByContact !== undefined) {
      this.makeData(this.$engine.monitoring.graphByContact)
    }
  },
  watch: {
    '$engine.monitoring.graphByContact': {
      handler (graphByContact) {
        if (graphByContact === undefined) {
          this.chartData = undefined
        } else {
          this.makeData(graphByContact)
        }
      },
      deep: true
    },
    $props: {
      handler () {
        if (this.$engine.monitoring.graphByContact !== undefined) {
          this.makeData(this.$engine.monitoring.graphByContact)
        }
      },
      deep: true
    }
  },
  methods: {
    makeData (graphByContact) {
      let dataToShow
      if (this.showSentNotReceived) { // Show Sent
        dataToShow = graphByContact.sent
      } else { // Show received
        dataToShow = graphByContact.received
      }
      if (this.showAmountNotNumber) { // Show Amount
        this.chartData = this.makeChartDataAmount(dataToShow)
      } else { // Show Number
        this.chartData = this.makeChartDataNumber(dataToShow)
      }
    },
    makeChartDataAmount (rawData) {
      let that = this
      let raw = R.clone(rawData)

      // Make and sort contact list by amount
      let contactList = []
      const sortByAmount = R.sortWith([R.descend(R.prop('amount'))])
      for (var contact in raw) {
        let alias = that.$engine.contacts.getAliasForIdentifier(contact)
        contactList = R.append({'contact': alias, 'amount': raw[contact].amount}, contactList)
      }
      contactList = sortByAmount(contactList)

      // Make data list
      let dataList = []
      contactList.forEach(entry => {
        dataList = R.append(entry.amount, dataList)
      })

      // Make chartData
      let chartData = {
        labels: R.map(entry => entry.contact, contactList),
        datasets: [{
          data: dataList,
          maxBarThickness: 20,
          label: 'Amount',
          backgroundColor: '#007bff',
          borderColor: '#007bff'
        }]
      }

      return chartData
    },
    makeChartDataNumber (rawData) {
      let that = this
      let raw = R.clone(rawData)

      // Make and sort contact list by amount
      let contactList = []
      const sortByNumber = R.sortWith([R.descend(R.prop('number'))])
      for (var contact in raw) {
        let alias = that.$engine.contacts.getAliasForIdentifier(contact)
        contactList = R.append({'contact': alias, 'number': raw[contact].number}, contactList)
      }
      contactList = sortByNumber(contactList)

      // Make data list
      let dataList = []
      contactList.forEach(entry => {
        dataList = R.append(entry.number, dataList)
      })

      // Make chartData
      let chartData = {
        labels: R.map(entry => entry.contact, contactList),
        datasets: [{
          data: dataList,
          label: 'Number',
          maxBarThickness: 20,
          backgroundColor: '#007bff',
          borderColor: '#007bff'
        }]
      }

      return chartData
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// GraphByContact.vue?7a6b1bc7